module.exports = __webpack_public_path__ + "assets/img/logo.24153a12.png";